import { Suspense } from "react";
import { Route } from "react-router-dom";
import SbLoading from "../../components/common/SbLoading";

const DefaultRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        window.dataLayer?.push({
          event: "gtm.load",
          pathname: props.location.pathname,
        });
        window.dataLayer?.push({
          event: "gtm.dom",
          pathname: props.location.pathname,
        });
        window.dataLayer?.push({
          event: "page_view",
          pathname: props.location.pathname,
        });
        return (
          <Suspense fallback={<SbLoading fullPage={true} />}>
            <Component {...props} />
          </Suspense>
        );
      }}
    />
  );
};

export default DefaultRoute;
